import React from "react";
import BlogsBanner from "./BlogsBanner";
import BlogsSection1 from "./BlogsSection1";
import BlogsSection2 from "./BlogsSection2";

const Blogs = () => {
  return (
    <div>
      <BlogsBanner></BlogsBanner>
      <BlogsSection1></BlogsSection1>
      <BlogsSection2></BlogsSection2>
    </div>
  );
};

export default Blogs;
